<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="450"
    height="50"
    viewBox="0 0 450 50"
  >
    <path
      id="Pfad_1"
      data-name="Pfad 1"
      d="M253.3,29.4l8.936-12.423H255.17L247.68,29.4,255.445,43.8h7.421Z"
      transform="translate(-33.906 -2.123)"
      fill="#b3b6b6"
    />
    <rect
      id="Rechteck_1"
      data-name="Rechteck 1"
      width="7.085"
      height="39.962"
      transform="translate(205.002 1.72)"
      fill="#b3b6b6"
    />
    <path
      id="Pfad_2"
      data-name="Pfad 2"
      d="M220.427,43.71V26.441c0-3.349-.921-5.286-3.994-5.286-4.046,0-7.016,4.261-7.016,9.607V43.676H203.64V16.911h5.475a35.567,35.567,0,0,1-.37,5.234l.052.052a9.8,9.8,0,0,1,9.332-5.828c6.1,0,7.989,3.831,7.989,8.609V43.71Z"
      transform="translate(-27.779 -2.037)"
      fill="#b3b6b6"
    />
    <path
      id="Pfad_3"
      data-name="Pfad 3"
      d="M191.8,43.709c-.112-2.264-.164-5.019-.164-7.335V25.415c0-5.5-2.264-9.065-10.468-9.065a26.619,26.619,0,0,0-7.085,1l.508,4.58h0a17.1,17.1,0,0,1,5.656-1.05c4.21,0,5.613,1.722,5.613,5.071v1.722c-9.659,0-15.814,3.564-15.814,9.719,0,4.3,2.918,6.887,7.507,6.887a9.366,9.366,0,0,0,8.9-5.561l.06.06a34.49,34.49,0,0,0-.276,4.959Zm-5.94-11.6c0,3.831-2.643,7.61-6.586,7.61-2.264,0-3.667-1.3-3.667-3.3,0-2.316,1.834-4.855,10.253-4.855Z"
      transform="translate(-23.106 -2.035)"
      fill="#b3b6b6"
    />
    <path
      id="Pfad_4"
      data-name="Pfad 4"
      d="M148.35,42.216a36.363,36.363,0,0,1-9.53-1.128V1.72h5.759v13.1a26.438,26.438,0,0,1-.482,5.114h.1a8.927,8.927,0,0,1,8.549-5.432c6.353,0,9.848,4.52,9.848,12.595C162.555,36.4,157.226,42.216,148.35,42.216Zm2.884-22.994c-4.3,0-6.637,5.019-6.637,9.556v8.308a13.774,13.774,0,0,0,4.21.542c4.589,0,7.748-2.806,7.748-10.038C156.52,22.192,154.85,19.222,151.234,19.222Z"
      transform="translate(-18.762 0)"
      fill="#b3b6b6"
    />
    <path
      id="Pfad_5"
      data-name="Pfad 5"
      d="M117.925,44.251a30.441,30.441,0,0,1-5.673-.542l.164-4.907a21.857,21.857,0,0,0,5.828.861c3.134,0,5.294-1.352,5.294-3.555,0-5.4-11.768-2.161-11.768-11.45,0-4.64,3.779-8.308,11.062-8.308a32.55,32.55,0,0,1,5.019.482l-.164,4.7a18.681,18.681,0,0,0-5.234-.758c-3.185,0-4.743,1.291-4.743,3.349,0,5.165,11.872,2.531,11.872,11.441C129.582,40.584,125.105,44.251,117.925,44.251Z"
      transform="translate(-14.998 -2.035)"
      fill="#727877"
    />
    <path
      id="Pfad_6"
      data-name="Pfad 6"
      d="M96.25,43.8a34.437,34.437,0,0,1,.379-5.234l-.069-.043a9.805,9.805,0,0,1-9.341,5.828c-6.1,0-7.989-3.831-7.989-8.609V17h5.725V34.218c0,3.34.913,5.286,3.994,5.286,4.046,0,7.016-4.3,7.016-9.607V17h5.768V43.8Z"
      transform="translate(-10.471 -2.126)"
      fill="#727877"
    />
    <path
      id="Pfad_7"
      data-name="Pfad 7"
      d="M67.264,43.709c-.112-2.264-.164-5.019-.164-7.335V25.415c0-5.5-2.264-9.065-10.468-9.065a26.618,26.618,0,0,0-7.085,1l.508,4.58h0a17.1,17.1,0,0,1,5.656-1.05c4.21,0,5.613,1.722,5.613,5.071v1.722c-9.659,0-15.814,3.564-15.814,9.719,0,4.3,2.918,6.887,7.507,6.887a9.366,9.366,0,0,0,8.9-5.587l.06.06a34.5,34.5,0,0,0-.275,4.959Zm-5.94-11.6c0,3.831-2.643,7.61-6.586,7.61-2.264,0-3.642-1.291-3.642-3.3,0-2.3,1.808-4.881,10.227-4.881Z"
      transform="translate(-5.78 -2.035)"
      fill="#727877"
    />
    <path
      id="Pfad_8"
      data-name="Pfad 8"
      d="M28.776,1.72V18.275H16.965L14.15,23.113H28.776V41.674h7.309V1.72Z"
      transform="translate(-1.418 0)"
      fill="#727877"
    />
    <rect
      id="Rechteck_2"
      data-name="Rechteck 2"
      width="7.309"
      height="39.962"
      transform="translate(3.96 1.72)"
      fill="#727877"
    />
  </svg>
</template>
